import { useTrainingStore } from '~/training/state';

const useIsDarkMode = () => {
  const darkMode = useTrainingStore(s => s.darkMode);

  if (!darkMode) return false;
  if (darkMode === 'dark') return true;
  if (darkMode === 'automatic')
    return window?.matchMedia('(prefers-color-scheme: dark)')?.matches;

  return false;
};

export default useIsDarkMode;
